import { render, staticRenderFns } from "./paymentItem.vue?vue&type=template&id=0bea57be&"
import script from "./paymentItem.vue?vue&type=script&lang=js&"
export * from "./paymentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports